import React, { useState, useEffect, useRef } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import { IoMdArrowBack } from "react-icons/io";
import useClickOutside from "../useClickOutside";
import ColdWorkPermitTemplate from "./ColdWorkPermitTemplate";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOM from "react-dom";

function Closerequesttab({ isSidebarExpanded }) {
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const fetchTimeout = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const { permit_id } = useParams();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [reason, setReason] = useState(""); // Track reason input
  const [selectedRenewalId, setSelectedRenewalId] = useState(null);
  const [actionDesignations, setActionDesignations] = useState([]);
  const [workPermitId, setWorkPermitId] = useState(null); // State for permit_id
  const [renewalId, setRenewalId] = useState(null); // State for renewal_id
  const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [selectedPermitId, setSelectedPermitId] = useState(null);
  const [closure_id, setClosure_id] = useState(null);
  const [isRejectPopupOpen, setIsRejectPopupOpen] = useState(false);
  const mapStatusToYesNo = (status) => (status === 1 ? "Yes" : "No");
  const handleApproveClick = (permitId, closure_id) => {
    setSelectedPermitId(permitId);
    setClosure_id(closure_id);
    setIsApprovePopupOpen(true);
  };

  // const handleRejectClick = (permit_id, renewal_id) => {
  //   setIsPopupOpen(true);
  //   // Save these IDs in the state or use them directly in the popup
  //   setWorkPermitId(permit_id); // Save permit_id in the state
  //   setRenewalId(renewal_id); // Save renewal_id in the state
  // };

  const handleRejectClick = async (permit_id, closure_id) => {
    if (!reason.trim()) {
      setSeverity("error");
      showSnackbar("Reason is required to reject the permit.");
      return;
    }

    const payload = {
      permit_id: permit_id, // Get from state
      closure_id: closure_id, // Get from state
      request_type: "closure", // Set `request_type` as "Close"
      reason: reason.trim(), // Trim whitespace from the reason
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      // Make the API call
      const response = await axios.post(
        `${API_URL}/api/reject_permit`,
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        // closePopup();
        setTimeout(() => {
          navigate(`/work-permit-inspection?tab=Closed`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    // Create a Date object from the date string
    const date = new Date(dateString);

    // Convert to UTC and format time
    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });

    // Format date to DD/MM/YYYY using UTC date methods
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
    const year = date.getUTCFullYear();

    // Combine to form the date string in DD/MM/YYYY format
    const dateStr = `${day}/${month}/${year}`;

    return `${dateStr}, ${time}`;
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleDeletePopup = () => {
    setIsDeletePopup(!isDeletePopup);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const fetchData = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_closure`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          permit_id: permit_id,
        },
      });

      console.log("response.data122112", response.data);
      setDesignations(response.data);
      // setDesignations(response.data || [{}]);
      setTotalItems(response.data.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching department data:", error.message);
      setLoading(false);
    }
  };

  const handleView = (workPermitId, work_permit_name, wp_status) => {

    const decodedWorkPermitName = decodeURIComponent(work_permit_name);

    console.log("twinkle work_permit_name", work_permit_name);
  console.log("twinkle decodedWorkPermitName", decodedWorkPermitName);

    // navigate(`/cold-work-permit-inspection-view/${workPermitId}`);
    navigate(
      `/view-pdf-formate/${workPermitId}/${work_permit_name}/${wp_status}`
    );
  };

  const fetchRenewalData = async (renewalId) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_permit_renewal`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          renewal_id: renewalId, // Use the passed renewal ID
        },
      });

      setActionDesignations(response.data); // Update state with the fetched data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching renewal data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isActionPopupOpen && selectedRenewalId) {
      fetchRenewalData(selectedRenewalId);
    }
  }, [isActionPopupOpen, selectedRenewalId]);

  const handleSearch = async (currentPage, itemsPerPage) => {
    if (!searchInput.trim()) {
      fetchData(currentPage, itemsPerPage);
      return;
    }
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/search_designations`, {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
        params: {
          query: searchInput,
          page: currentPage,
          per_page: itemsPerPage,
        },
      });

      if (response.status === 200) {
        setDesignations(response.data.Designations);
      } else {
        console.error("Error fetching search results:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    clearTimeout(fetchTimeout.current);

    // Debounce API calls by 600ms
    fetchTimeout.current = setTimeout(() => {
      if (searchInput.trim() === "") {
        fetchData(page, itemsPerPage);
      } else {
        setIsSearching(true);
        handleSearch(page, itemsPerPage);
      }
    }, 600);

    return () => clearTimeout(fetchTimeout.current);
  }, [searchInput, page, itemsPerPage]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleArchivedDesignation = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/archive_designations`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        showSnackbar("Data archived successfully");
        const updatedDesignations = designations.filter(
          (designation) => !selectedRows.includes(designation.id)
        );
        setDesignations(updatedDesignations);
        fetchData();
        setSelectedRows([]);
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to delete departments");
      }
    } catch (error) {
      console.error("An error occurred while deleting designations:", error);
    }
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };
  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };

  const handleCloseRequest = async (permit_id, closure_id) => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await axios.put(
        // `${API_URL}/api/issuer/approve_close_permit_request`,
        `${API_URL}/api/v2/issuer/submit_for_review`,
        {
          permit_id: permit_id,
          closure_id: closure_id,
          request_type: "closure",
        },
        {
          headers: {
            Authorization: authKey,
          },
        }
      );
      if (response.status === 200) {
        // setSeverity("success");
        showSnackbar("Work permit closed successfully!");
        await fetchData(page, itemsPerPage);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
    } finally {
      setIsLoading(false);
    }
  };
  const handleConfirmApprove = (permitId, closure_id) => {
    console.log(`Approving permit with ID: ${permitId}`);

    // Call your existing approve function
    handleCloseRequest(permitId, closure_id);

    // Close the popup
    setIsApprovePopupOpen(false);
  };

  // Close reject popup
  const handleRejectClose = () => {
    setIsRejectPopupOpen(false);
  };

  const statusColors = {
    Pending: { color: "#D97706", fontWeight: "600" }, // Orange
    "Closure Rejected": { color: "#DC2626", fontWeight: "600" }, // Red
    "Closure Approved by Issuer": { color: "#059669", fontWeight: "600" }, // Green
    default: { color: "#6B7280" }, // Grey
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {isChecked ? (
            <div className="action-header">
              <div className="action-header-content">
                <div className="action-header-content-leftside">
                  <div className="action-button">
                    <button className="delete" onClick={handleDeletePopup}>
                      Move to archive
                    </button>
                    {isDeletePopup && (
                      <div className="confirm-delete-popup">
                        <div className="confirm-delete-popup-content">
                          <div className="confirm-model">
                            <div className="confirm-model-content">
                              <div className="confirm-model-content-body">
                                <p>Are you sure want to move archive?</p>
                              </div>
                              <div className="confirm-model-content-footer">
                                <button
                                  className="confirm-delete-button"
                                  onClick={handleArchivedDesignation}
                                >
                                  Yes
                                </button>
                                <button
                                  className="confirm-cancel-button"
                                  onClick={handleCancel}
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="action-header-content-rightside">
                  <button
                    className="action-header-close-button"
                    onClick={handleCloseButtonClick}
                  >
                    <IoCloseOutline className="action-header-close-icon" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="data-list-header">
              <div className="data-list-header-content">
                <div className="data-list-heading-content-left-side">
                  <Tooltip title="Back" arrow>
                    <IoMdArrowBack
                      className="back-company"
                      onClick={handleBack}
                    />
                  </Tooltip>
                  View Close Request
                </div>
                <div className="data-list-heading-content-right-side">
                  <Tooltip title="Refresh List" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : designations.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th>COMPLETED</th>
                        <th>STOPPED</th>
                        <th>AREA CLEANED</th>
                        <th>STATUS</th>
                        <th>REQUETED AT</th>
                        <th>CLOSED AT</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {designations.map((designation, index) => (
                        <tr key={designation.id} className="hoverable-row">
                          <td className="center-alignment">{index + 1}</td>
                          <td>
                            {mapStatusToYesNo(
                              designation.completion_status || "NA"
                            )}
                          </td>
                          <td>
                            {mapStatusToYesNo(
                              designation.stoppage_status || "NA"
                            )}
                          </td>
                          <td>
                            {mapStatusToYesNo(
                              designation.area_cleaned_status || "NA"
                            )}
                          </td>
                          <td
                            style={
                              statusColors[designation.status] ||
                              statusColors.default
                            }
                          >
                            {designation.status || "NA"}
                          </td>
                          <td>
                            {formatDateTime(
                              designation.receiver_date_time || "NA"
                            )}
                          </td>
                          <td>
                            {formatDateTime(designation.closed_at || "NA")}
                          </td>

                          <td>
                            <>
                              <button
                                className="new-button-download"
                                onClick={() =>
                                  handleView(
                                    designation.permit_id,
                                    designation?.work_permit_name,
                                    "wp_issuer"
                                  )
                                }
                              >
                                View
                              </button>
                              {/* Approve Button */}
                              <button
                                className="new-button-download approve_btn_clr"
                                onClick={() =>
                                  handleApproveClick(
                                    designation.permit_id,
                                    designation.id
                                  )
                                }
                                disabled={
                                  designation.issuer_approval_status === 1
                                }
                              >
                                {loading ? "Approving.." : "Approve"}
                              </button>

                              {/* Reject Button */}
                              <button
                                className="data-form-reject-button"
                                onClick={() => setIsPopupOpen(true)}
                                disabled={
                                  designation.issuer_approval_status === 1
                                }
                              >
                                Reject
                              </button>

                              {/* Reject Popup */}
                              {isPopupOpen && (
                                <div className="permit-popup-model">
                                  <div className="form-permit-popup-content">
                                    <div className="reminder-popup-model-header">
                                      <div className="reminder-popup-model-content-header">
                                        <div className="reminder-popup-model-content-header-left-part">
                                          Reject Permit
                                        </div>
                                      </div>
                                      <div className="permit-popup-new-form">
                                        <form className="form-permit-popup-detail">
                                          <div className="new-data-form">
                                            <div className="new-form-group email-field">
                                              <label htmlFor="reason">
                                                Reason for rejection{" "}
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="input-group">
                                                <textarea
                                                  id="reason"
                                                  name="reason"
                                                  placeholder="Enter reason"
                                                  value={reason}
                                                  onChange={handleReasonChange}
                                                  rows="4"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                      <div className="footers">
                                        <div className="form-button-group">
                                          <button
                                            className="form-reject-button"
                                            type="button"
                                            onClick={() => {
                                              handleRejectClick(
                                                designation.permit_id,
                                                designation.id
                                              );
                                              closePopup();
                                            }}
                                          >
                                            {loading ? "Rejecting.." : "Reject"}
                                          </button>
                                          <button
                                            className="person-user-cancel-button"
                                            onClick={closePopup}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Approval Confirmation Popup */}
                              {isApprovePopupOpen && (
                                <div className="confirm-delete-popup">
                                  <div className="confirm-delete-popup-content">
                                    <div className="confirm-model">
                                      <div className="confirm-model-content">
                                        <div className="confirm-model-content-body">
                                          <p>Are you sure want to approve?</p>
                                        </div>
                                        <div className="confirm-model-content-footer">
                                          <button
                                            className="confirm-delete-button"
                                            onClick={() =>
                                              handleConfirmApprove(
                                                selectedPermitId,
                                                closure_id
                                              )
                                            }
                                          >
                                            Yes
                                          </button>
                                          <button
                                            className="confirm-cancel-button"
                                            onClick={() =>
                                              setIsApprovePopupOpen(false)
                                            }
                                          >
                                            No
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Reject Popup */}
                              {isRejectPopupOpen && (
                                <div className="permit-approval-popup">
                                  <div className="permit-approval-popup-content">
                                    <div className="approval-popup-header">
                                      Reject Request
                                    </div>
                                    <div className="popup-new-form">
                                      <label htmlFor="reason">
                                        Reason{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <textarea
                                        id="reason"
                                        name="reason"
                                        placeholder="Enter reason for rejection"
                                        value={reason}
                                        onChange={handleReasonChange}
                                      />
                                    </div>
                                    <div className="approval-popup-buttons">
                                      <button
                                        className="approve-button"
                                        onClick={() => {
                                          handleRejectClick(
                                            designation.permit_id,
                                            designation.id,
                                            reason
                                          );
                                          handleRejectClose();
                                        }}
                                      >
                                        Reject
                                      </button>
                                      <button
                                        className="cancel-button"
                                        onClick={handleRejectClose}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Data Found</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Closerequesttab;
